import { DateTime } from 'luxon'
import { TTaskV4 } from '../../utils/types'

/** A goal's linked tasks, oldest first so a new task appends at the bottom. */
export const linkedTasksForGoal = (goalId: string, tasks: TTaskV4[] | undefined, links: Record<string, string>) =>
    (tasks ?? [])
        .filter((t) => goalIdForTask(links, t) === goalId && !t.is_deleted)
        .sort((a, b) => a.created_at.localeCompare(b.created_at))

/** A task's goal, whether it was linked under its real id or its optimistic id. */
export const goalIdForTask = (links: Record<string, string>, task: Pick<TTaskV4, 'id' | 'optimisticId'>) =>
    links[task.id] ?? (task.optimisticId ? links[task.optimisticId] : undefined)

/** "In Today" is the Daily Overview's due-today view, so it reads the same due date rule. */
export const isDueToday = (task: Pick<TTaskV4, 'due_date'>) =>
    !!task.due_date && DateTime.fromISO(task.due_date).hasSame(DateTime.local(), 'day')

const dueMillis = (task: TTaskV4) => {
    const due = task.due_date ? DateTime.fromISO(task.due_date) : null
    return due?.isValid && +due !== 0 ? +due : Infinity
}

/** Next up: open tasks, today's first, then by due date, undated last (creation order breaks ties). */
export const nextUpOrder = (tasks: TTaskV4[]) =>
    tasks
        .filter((t) => !t.is_done)
        .sort((a, b) => Number(isDueToday(b)) - Number(isDueToday(a)) || dueMillis(a) - dueMillis(b))
